/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
  Snackbar,
  Alert,
  Modal,
  IconButton,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Popper,
  Paper,
  ClickAwayListener,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import "./style.css";
import { AuthenticationApi } from "../../../../API/Authentication/LoginApi";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import CircularProgress from "@mui/material/CircularProgress";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";

const FleetDailyReport = () => {
  type Merchant = {
    merchantId: number;
    merchantName: string;
    merchantLogoId?: number; // optional because not all entries have it
  };
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState<any>();
  const [kycDetailListData, setKycDetailListData] = useState<any[]>([]);
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [statusType, setStatusType] = useState<any>();
  const handleCloseDocumentModal = () => setOpenDocumentModal(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [documents, setDocuments] = useState<any[]>([]); // <-- Added
  const [loadingDocuments, setLoadingDocuments] = useState(false); // <-- Added
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [approvePhone, setApprovePhone] = useState("");
  const [approveClientUserId, setApproveClientUserId] = useState("");
  const [merchants, setMerchants] = useState<Merchant[]>([]);
  const [selectedMerchant, setSelectedMerchant] = useState("");
  const handleCloseRemarks = () => setOpen(false);
  const [userRole, setUserRole] = useState<string | null>(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  useEffect(() => {
    const role = localStorage.getItem("authority");
    setUserRole(role);
  }, [userRole]);
console.log('userRole', userRole)
  const rowsPerPage = 20;
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const userid = selectedItem?.id;
  const handleDownloadAllDocuments = async () => {
    const zip = new JSZip();

    for (const doc of documents) {
      for (const [idx, imageId] of (doc.imageIds || []).entries()) {
        if (imageId) {
          try {
            const response = await fetch(getImageUrl(imageId));
            const blob = await response.blob();
            const fileExtension = blob.type.split("/")[1]; // like 'jpeg' or 'png'
            zip.file(`${doc.title}_${idx + 1}.${fileExtension}`, blob);
          } catch (error) {
            console.error("Error downloading image:", imageId, error);
          }
        }
      }
    }

    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, "KYC_Documents.zip");
  };
  // Function to get the full Image URL
  const getImageUrl = (imageId: string) => {
    return `https://preprod.bcykal.com/mobycy/api/media/file/${imageId}`; // <-- Change this to your real URL
  };

  // Function to download an image
  const downloadImage = (imageId: string) => {
    const link = document.createElement("a");
    link.href = getImageUrl(imageId);
    link.download = `${imageId}.jpg`;
    link.click();
  };
  const handleSendLink = async (id: any) => {
    try {
      const response = await AuthenticationApi.api?.getLinkSend(id);

      if (response?.message === "success") {
        setSnackbarMessage("Link sent successfully");
        setSnackbarSeverity("success");
        fetchKycData(); // Refresh list
      } else {
        setSnackbarMessage("Failed to send link");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error sending link:", error);
      setSnackbarMessage("Error sending link");
      setSnackbarSeverity("error");
    } finally {
      setShowErrorSnackbar(true);
      handleMenuClose();
    }
  };

  const handleOpenDocumentModal = async (userId: any) => {
    setOpenDocumentModal(true);
    setLoadingDocuments(true);
    try {
      const response = await AuthenticationApi.api?.getAllDocuments(userId);
      if (response?.data?.length > 0) {
        setDocuments(response.data);
      } else {
        setDocuments([]);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
      setDocuments([]);
    } finally {
      setLoadingDocuments(false);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleApprove = async () => {
    try {
      const response = await AuthenticationApi.api?.approveClientRequest({
        id: userid,
        phoneNumber: approvePhone,
        clientUserId: approveClientUserId,
      });

      if (response?.code === 2000) {
        setSnackbarMessage("Client request approved successfully!");
        setSnackbarSeverity("success");
        setShowErrorSnackbar(true);
        setOpenApproveModal(false);
        fetchKycData(); // Refresh list
      } else {
        setSnackbarMessage(response?.message || "Approval failed");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    } catch (error: any) {
      console.error("Error during approval:", error);

      const message =
        error?.response?.data?.message ||
        error?.message ||
        "An unexpected error occurred";

      setSnackbarMessage(message);
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    }
  };

  const pageRange = 5;

  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#A4A2A2",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };
  const fetchMerchantlist = () => {
    AuthenticationApi.api
      ?.MerchantListData()
      .then((data) => {
        setMerchants(data as unknown as Merchant[]);
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };

  const fetchKycData = () => {
    AuthenticationApi.api
      ?.ClientIdVerification(
        page,
        rowsPerPage,
        searchValInput,
        statusType,
        selectedMerchant
      )
      .then((response) => {
        if (response.data.length > 0) {
          setKycDetailListData(response.data);
          setTotalCount(response.count);
        } else {
          setKycDetailListData([]);
          setTotalCount(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };
  console.log("countcheck", totalCount);
  useEffect(() => {
    fetchKycData();
    fetchMerchantlist();
  }, [page, rowsPerPage, searchValInput, statusType, selectedMerchant]);
  const handleReject = async () => {
    try {
      const response = await AuthenticationApi.api?.rejectClientRequest(
        userid,
        query
      );

      if (response?.message === "success" && response?.code === 0) {
        setSnackbarMessage("Client request rejected successfully!");
        setSnackbarSeverity("success");
        setShowErrorSnackbar(true);
        setOpen(false);
        setQuery(""); // Clear the input after submission
        fetchKycData(); // 🔄 Refresh the KYC list
      } else {
        setSnackbarMessage("Failed to reject client request.");
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      }
    } catch (error) {
      console.error("Error during rejection:", error);
      setSnackbarMessage("An error occurred during rejection.");
      setShowErrorSnackbar(true);
    } finally {
      handleMenuClose();
    }
  };
  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };

  return (
    <div>
      <AppHeader />
      <div className="px-10">
        <div className="py-6">
          <Typography variant="h4">Client Ticket Dashboard</Typography>
        </div>
        <Box sx={{ bgcolor: "#3b3b3b", width: "100%" }}></Box>

        <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl">
          <div className="w-full">
            <Grid
              container
              spacing={5}
              className="w-full flex justify-between items-center"
            >
              <Grid item md={3}>
                <div className="flex ml-4">
                  <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                    User Client ID details
                  </h2>
                </div>
              </Grid>
              <Grid item md={9}>
                <div className="flex mr-4">
                  <div className="flex w-full justify-end">
                    <div
                      className="flex items-center bg-white border border-[#3b3b3b] border-solid rounded-full px-2 py-1 mr-2"
                      style={{ height: "40px" }}
                    >
                      <div>
                        <Typography className="font-inter text-[#727597] text-xs mr-2 font-normal">
                          Client:
                        </Typography>
                      </div>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <select
                          id="merchant"
                          value={selectedMerchant}
                          onChange={(e) => setSelectedMerchant(e.target.value)}
                        >
                          <option value="">Select Merchant</option>
                          {merchants.map((merchant) => (
                            <option
                              key={merchant.merchantId}
                              value={merchant.merchantId}
                            >
                              {merchant.merchantName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div
                      className="flex items-center bg-white border border-[#3b3b3b] border-solid rounded-full px-2 py-1 mr-2"
                      style={{ height: "40px" }}
                    >
                      <div>
                        <Typography className="font-inter text-[#727597] text-xs mr-2 font-normal">
                          Status:
                        </Typography>
                      </div>
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <select
                          id="battery"
                          value={statusType}
                          onChange={(e) => setStatusType(e.target.value)}
                          style={{
                            borderRadius: "5px",
                            paddingRight: "30px",
                            padding: "5px",
                            border: "none",
                          }}
                        >
                          <option value=""> All</option>
                          <option value="PENDING">Pending</option>
                          <option value="APPROVAL_PENDING">
                            Approval Pending
                          </option>
                          <option value="REQUEST_SENT">Request Sent</option>
                          <option value="INITIATED">Initiated</option>
                          <option value="LINK_INITIATED">Link Initiated</option>
                          <option value="LINK_SEND">Link Sent</option>
                          <option value="FOLLOW_STEPS">Follow Steps</option>
                          <option value="SELECTED">Selected</option>
                          <option value="ACTIVATE_NOW">Activate Now</option>
                          <option value="APPROVED">Approved</option>
                          <option value="REJECTED">Rejected</option>
                        </select>
                      </div>
                    </div>
                    <div className="mr-3">
                      <TextField
                        placeholder="Search  By Mobile Number"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={(search: any) =>
                          setSearchValInput(search.target.value)
                        }
                        value={searchValInput}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              onClick={handleClearSearch}
                            >
                              <ClearIcon style={{ cursor: "pointer" }} />
                            </InputAdornment>
                          ),
                          style: { height: "40px", borderRadius: "25px" },
                        }}
                        // onKeyDown={handleKeyPress}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <hr className="my-4" />

            <TableContainer style={{ width: "100%", overflowX: "auto" }}>
              {!kycDetailListData ? ( // Check if API response is still undefined (loading)
                <LinearProgress />
              ) : typeof kycDetailListData === "string" ? ( // If API returns "No Data Found" as a string
                <Typography style={{ textAlign: "center", padding: "10px" }}>
                  No data available
                </Typography>
              ) : kycDetailListData.length === 0 ? ( // If the array is empty
                <Typography style={{ textAlign: "center", padding: "10px" }}>
                  No data available
                </Typography>
              ) : (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 110 }}
                      >
                        User Id
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 110 }}
                      >
                        Mobile No
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 120 }}
                      >
                        Client Mobile No
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 110 }}
                      >
                        Client Id
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Status
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Client Name
                      </TableCell>
                      <TableCell
                        style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                        sx={{ minWidth: 100 }}
                      >
                        Document
                      </TableCell>
                       {userRole &&
                        ![
                          "ROLE_CITY_HEAD"
                        ].includes(userRole) && (
                          <TableCell
                            style={{
                              ...tableHeaderCellStyle,
                              textAlign: "center",
                            }}
                            sx={{ minWidth: 100 }}
                          >
                            Action
                          </TableCell>
                        )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {kycDetailListData.map((item: any, index: any) => (
                      <TableRow key={index}>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.userId}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.name}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.userPhoneNumber}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.mobileNo}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.clientId}
                        </TableCell>
                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          <p
                            style={{
                              color:
                                item.status === "APPROVAL_PENDING" ||
                                item.status === "PENDING"
                                  ? "#f5be08"
                                  : item.status === "APPROVED"
                                  ? "green"
                                  : item.status === "REJECTED"
                                  ? "red"
                                  : "#666", // random/default color for others
                              fontWeight: "bold",
                            }}
                          >
                            {item.status.toUpperCase().split("_").join(" ")}
                          </p>
                        </TableCell>

                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          {item.merchantDetails.merchantName}
                        </TableCell>

                        <TableCell
                          style={{ ...tableBodyCellStyle, textAlign: "center" }}
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <img
                              src={"/assets/document.svg"}
                              alt="document"
                              onClick={() =>
                                handleOpenDocumentModal(item.userId)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </Box>
                        </TableCell>
                         {userRole &&
                        ![
                          "ROLE_CITY_HEAD"
                        ].includes(userRole) && (
                        <TableCell
                          style={{
                            ...tableHeaderCellStyle,
                            textAlign: "center",
                            cursor:
                              item.status === "REJECTED"
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          <IconButton
                            onClick={(event) => {
                              if (item.status !== "REJECTED") {
                                setAnchorEl(event.currentTarget);
                                setSelectedItem(item);
                                setApprovePhone("");
                                setApproveClientUserId("");
                              }
                            }}
                            disabled={item.status === "REJECTED"}
                          >
                            <MoreVertIcon />
                          </IconButton>

                          <Popper
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            placement="bottom-end"
                            style={{ zIndex: 1300 }}
                          >
                            <ClickAwayListener
                              onClickAway={() => setAnchorEl(null)}
                            >
                              <Paper
                                sx={{
                                  p: 1,
                                  borderRadius: 1,
                                  textAlign: "left",
                                  boxShadow: "0px 4px 4px #ccc",
                                }}
                              >
                                {selectedItem?.status !== "LINK_INITIATED" &&
                                selectedItem?.status !== "APPROVAL_PENDING" ? (
                                  <Button
                                    fullWidth
                                    variant="text"
                                    sx={{ width: "auto" }}
                                    startIcon={
                                      <CheckCircleRoundedIcon
                                        sx={{ color: "green" }}
                                      />
                                    }
                                    onClick={() => {
                                      setApprovePhone(
                                        selectedItem.mobileNo || ""
                                      );
                                      setApproveClientUserId(
                                        selectedItem.clientId || ""
                                      );
                                      setOpenApproveModal(true);
                                      setAnchorEl(null);
                                    }}
                                  >
                                    Approve
                                  </Button>
                                ) : selectedItem?.status !==
                                  "APPROVAL_PENDING" ? (
                                  <Button
                                    fullWidth
                                    variant="text"
                                    sx={{ width: "auto" }}
                                    onClick={() => {
                                      handleSendLink(selectedItem.id);
                                      setAnchorEl(null);
                                    }}
                                  >
                                    Send Link
                                  </Button>
                                ) : null}

                                <Button
                                  fullWidth
                                  variant="text"
                                  sx={{ width: "auto" }}
                                  startIcon={
                                    <CancelRoundedIcon sx={{ color: "red" }} />
                                  }
                                  onClick={() => {
                                    handleOpen(); // open your reject modal
                                    setAnchorEl(null);
                                    setQuery(""); // Clear the input after submission
                                  }}
                                >
                                  Reject
                                </Button>
                              </Paper>
                            </ClickAwayListener>
                          </Popper>
                        </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer>

            <div className="pl-2 pt-4 pb-2 pr-16">
              <div
                className="pagination"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 0}
                    style={{
                      fontFamily: "Rubik",
                      fontSize: "20px",
                      marginRight: "6px",
                    }}
                  >
                    {"<"}
                  </button>
                  {renderPageNumbers()}
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page >= pageCount - 1}
                    style={{
                      fontFamily: "Rubik",
                      fontSize: "20px",
                      marginLeft: "6px",
                    }}
                  >
                    {">"}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Snackbar
            open={showErrorSnackbar}
            autoHideDuration={6000}
            onClose={() => setShowErrorSnackbar(false)}
          >
            <Alert
              onClose={() => setShowErrorSnackbar(false)}
              severity={snackbarSeverity}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}></Box>
        <Dialog
          open={openApproveModal}
          onClose={() => setOpenApproveModal(false)}
        >
          <DialogTitle>Approve Client Request</DialogTitle>
          <DialogContent>
            <TextField
              label="Phone Number"
              fullWidth
              margin="dense"
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 10,
              }}
              value={approvePhone}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                if (onlyNums.length <= 10) {
                  setApprovePhone(onlyNums);
                }
              }}
            />

            <TextField
              label="Client User ID"
              fullWidth
              margin="dense"
              value={approveClientUserId}
              onChange={(e) => setApproveClientUserId(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="error"
              onClick={() => setOpenApproveModal(false)}
            >
              Cancel
            </Button>
            <Button onClick={handleApprove} variant="contained" color="success">
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              width: 400,
            }}
          >
            <Grid className="flex justify-between items-center mb-3">
              <Grid>
                <h2 className="mb-2">
                  Remarks <span style={{ color: "red" }}>*</span>
                </h2>
              </Grid>
              <Grid>
                <IconButton onClick={handleCloseRemarks}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <TextField
              // label="Remarks"
              multiline
              rows={4}
              fullWidth
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                color="success"
                onClick={handleReject}
                disabled={!query.trim()}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={openDocumentModal}
          onClose={handleCloseDocumentModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute" as "absolute",
              top: "10%",
              left: "50%",
              transform: "translate(-50%, 0)",
              width: 600,
              maxHeight: "80vh",
              bgcolor: "background.paper",
              border: "2px solid #000",
              boxShadow: 24,
              p: 4,
              borderRadius: "10px",
              overflowY: "auto",
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography id="modal-title" variant="h6" component="h2">
                Document List
              </Typography>
              <Box display="flex" gap={1}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleDownloadAllDocuments}
                  disabled={documents.length === 0}
                >
                  Download All
                </Button>
                <IconButton onClick={handleCloseDocumentModal}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>

            {/* Show loader while fetching */}
            {loadingDocuments ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="200px"
              >
                <CircularProgress />
              </Box>
            ) : documents.length === 0 ? (
              <Typography textAlign="center" mt={4}>
                No documents available
              </Typography>
            ) : (
              documents.map((doc, index) => (
                <Box mt={3} key={index}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    {index + 1}. {doc.title?.toUpperCase()}
                  </Typography>

                  <Box display="flex" gap={2} mt={1} flexWrap="wrap">
                    {doc.imageIds?.map((imageId: string, imgIdx: number) =>
                      imageId ? (
                        <Box
                          key={imgIdx}
                          sx={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            minHeight: "200px",
                            width: "48%",
                            position: "relative",
                            overflow: "hidden",
                          }}
                        >
                          <Zoom>
                            <img
                              src={getImageUrl(imageId)}
                              alt={`${doc.title}_${imgIdx}`}
                              style={{
                                width: "100%",
                                height: "200px",
                                objectFit: "cover",
                              }}
                            />
                          </Zoom>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ position: "absolute", bottom: 8, right: 8 }}
                            onClick={() => downloadImage(imageId)}
                          >
                            Download
                          </Button>
                        </Box>
                      ) : (
                        <Box
                          key={imgIdx}
                          sx={{
                            border: "1px solid #ccc",
                            minHeight: "200px",
                            width: "48%",
                            borderRadius: "8px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "grey",
                          }}
                        >
                          No Image
                        </Box>
                      )
                    )}
                  </Box>
                </Box>
              ))
            )}
          </Box>
        </Modal>
      </div>
    </div>
  );
};

export default FleetDailyReport;
